import { Injectable, signal } from '@angular/core';
import { SetupConfig } from 'src/app/services/_offline/rep-setup.service';

@Injectable({ providedIn: 'root' })
export class OpenRepProgressService {
  public readonly isRepProgressModalOpen = signal(false);
  public readonly setupConfig = signal<SetupConfig>(undefined);
}
